import {gql} from "@apollo/client";

export const CREATE_CAC_CLIENT = gql`
  mutation create($input: CacClientInput!){
      create(input: $input){
        _id
        companyName
        active
        apiKey
        phoneNumber
        address
        email
        rcNumber
        wallet
        beebotCacPrice
        beebotCacCompanyRegPrice
        callbackUrl
        clientRef
        vasApiKey
      }
    }   
`;
export const UPDATE_WALLET_BALANCE = gql`
  mutation updateCacClientWallet($input: CacClientWalletUpdateInput!){
      updateCacClientWallet(input: $input){
        _id
        wallet
      }
    }   
`;

export const UPDATE_CAC_CLIENT = gql`
  mutation updateCacClient($input: UpdateCacClientInput!){
      updateCacClient(input: $input){
        _id
        companyName
        active
        apiKey
        phoneNumber
        address
        email
        rcNumber
        wallet
        beebotCacPrice
        beebotCacCompanyRegPrice
        callbackUrl
        vasApiKey
      }
    }   
`;

export const TOGGLE_EDITABLE = gql`
    mutation toggle($id: String!){
      toggleEditable(id: $id){
        _id
        editable
      }
    }
`;

export const REDOWNLOAD_CERTIFICATE_AND_STATUS_REPORT = gql`
  mutation RedownloadCertificateAndStatusReport($id: String!) {
    redownloadCertificateAndStatusReport(id: $id) {
      success
      message
      business {
        _id
        certificate
        statusReport
      }
    }
  }
`;

export const SUBSCRIBE_TO_AUTO_APPROVAL = gql`
  mutation SubscribeToAutoApproval($id: String!) {
    subscribeToAutoApproval(id: $id) {
      _id
      autoApprovalSubscribed
      transactionRef
      status
    }
  }
`;

export const UPDATE_CAC_REG_STATUS_WITH_FILES = gql`
  mutation UpdateCacRegStatusWithFiles($input: UpdateStatusInput!) {
    updateCacRegStatusWithFiles(input: $input) {
      _id
      status
      certificate
      statusReport
      transactionRef
    }
  }
`;

export const RESEND_CAC_REGISTRATION_EMAIL = gql`
  mutation ResendCacRegistrationEmail($id: String!) {
    resendCacRegistrationEmail(id: $id)
  }
`;

export const DELETE_CAC_CLIENT = gql`
  mutation deleteCacClient($id: String!) {
    deleteCacClient(id: $id) {
      success
      message
    }
  }
`;